import { Controller } from "@hotwired/stimulus"

// Stimulus controller for tabbed show pages.
//
// Persists the active tab in the URL hash so bookmarking and page reload
// restore the same tab. On connect it reads the hash; on tab click it updates it.
//
// Usage (generated by TabsHelper):
//   <div data-controller="tabs" data-tabs-record-value="product_42">
//     <ul class="nav nav-tabs">
//       <li><button data-action="tabs#select"
//                   data-tabs-name-param="details" ...>Details</button></li>
//     </ul>
//     <div class="tab-content">...</div>
//   </div>
//
export default class extends Controller {
  static values = {
    record: String   // DOM key prefix, e.g. "product_42"
  }

  connect() {
    this.restoreFromHash()
    window.addEventListener("hashchange", this.handleHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.handleHashChange)
  }

  // Action: called on tab button click via data-action="tabs#select"
  select(event) {
    const name = event.params.name
    if (name) {
      this.updateHash(name)
    }
  }

  // Reads the current URL hash and activates the matching tab if found.
  restoreFromHash() {
    const hash = window.location.hash.replace("#", "")
    if (!hash) return

    const tabId = `tab_${this.recordValue}_${hash}`
    const tabButton = this.element.querySelector(`#${CSS.escape(tabId)}`)

    if (tabButton && !tabButton.classList.contains("active")) {
      // Use Bootstrap's Tab API to switch
      const bsTab = new bootstrap.Tab(tabButton)
      bsTab.show()
    }
  }

  // Arrow function so `this` is preserved when used as event listener
  handleHashChange = () => {
    this.restoreFromHash()
  }

  updateHash(name) {
    history.replaceState(null, "", `#${name}`)
  }
}
